import * as React from 'react';
import cx from 'classnames';

import AvatarWithText from 'components/AvatarWithText';
import ErrorReporter from 'app/components/ErrorReporter';
import LinkBase from 'components/LinkBase';
import MediaObject from 'components/MediaObject';
// @ts-ignore
import Group from 'entities/Group';
// @ts-ignore
import Organization from 'entities/Organization';
// @ts-ignore
import User from 'entities/User';
// @ts-ignore
import GroupAvatarWithText from 'groups/components/GroupAvatarWithText';
// @ts-ignore
import OrganizationAvatarWithText from 'organizations/components/OrganizationAvatarWithText';
// @ts-ignore
import UsersAvatarWithText from 'users/components/UsersAvatarWithText';

import { MouseEventHandler } from 'types/typescript/eventHandlers';

import './AvatarWithTextItem.scss';

type Props = {
  action?: React.ReactElement;
  group?: Group;
  href?: string;
  onClick?: MouseEventHandler;
  organization?: Organization;
  to?: string;
  user?: User;
  avatar?: React.ReactElement;
  title?: string | React.ReactElement;
  subtext?: React.ReactElement | string;
  subtle?: boolean;
};

class AvatarWithTextItem extends React.Component<Props> {
  renderAvatarWithText = () => {
    const { user, group, organization, avatar, ...others } = this.props;

    if (user) {
      return <UsersAvatarWithText user={user.toJSON()} {...others} />;
    } else if (group) {
      return <GroupAvatarWithText group={group} {...others} />;
    } else if (organization) {
      return <OrganizationAvatarWithText organization={organization} {...others} />;
    } else if (avatar) {
      return <AvatarWithText avatar={avatar} {...others} />;
    }

    return (
      <ErrorReporter error="AvatarWithTextItem tried to render without any of the following props: user, group, organization, or avatar">
        <AvatarWithText avatar={<span />} {...others} />
      </ErrorReporter>
    );
  };

  renderBody = (avatarWithText: React.ReactNode) => {
    const { action } = this.props;

    if (action) {
      return (
        <MediaObject center figure="right">
          {avatarWithText}
          {action}
        </MediaObject>
      );
    }

    return avatarWithText;
  };

  renderComponent = (children: React.ReactNode) => {
    const { href, to, onClick } = this.props;

    if (href || to) {
      return (
        <LinkBase
          href={href}
          to={to}
          className={cx('AvatarWithTextItem', 'AvatarWithTextItem--interactive')}>
          {children}
        </LinkBase>
      );
    } else if (onClick) {
      return (
        <button
          onClick={onClick}
          className={cx('AvatarWithTextItem', 'AvatarWithTextItem--interactive')}>
          {children}
        </button>
      );
    }

    return <div className={'AvatarWithTextItem'}>{children}</div>;
  };

  render() {
    const avatarWithText = this.renderAvatarWithText();
    return this.renderComponent(this.renderBody(avatarWithText));
  }
}

export default AvatarWithTextItem;
